export default __webpack_public_path__ + "static/media/sat-3.24fd0ec1.png";